// UI-shell state (collapsed panels) — localStorage, deliberately NOT part of
// the Prefs settings blob: it is per-device layout, not a user preference.
// The dock WIDTH is kept apart, under tracecad.dock.width (dockWidth.ts).
const KEY = "tracecad.uiPrefs";

export interface UiPrefs {
  collapsed: Record<string, boolean>; // panel id → collapsed
}

const DEFAULTS: UiPrefs = { collapsed: {} };

export function loadUiPrefs(): UiPrefs {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { ...DEFAULTS, collapsed: {} };
    const parsed = JSON.parse(raw) as Partial<UiPrefs>;
    return {
      collapsed: parsed.collapsed && typeof parsed.collapsed === "object" ? { ...parsed.collapsed } : {}
    };
  } catch {
    return { ...DEFAULTS, collapsed: {} };
  }
}

export function saveUiPrefs(prefs: UiPrefs): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(prefs));
  } catch {
    // storage unavailable (private mode) — layout just won't persist
  }
}
